<template>
	<button
			:class="[
					'success-btn button',
					'size-'+size,
					'width-'+width,
			]"
			@click.prevent.stop="onClick"
			:disabled="disabled"
	>
			{{ label }}
	</button>
</template>
<script>
	export default {
		name: 'SimplementsSuccessButton',
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean
			},
			size: {
				type: String,
				default: 'lg'
			},
			width: {
				type: String,
				default: 'full'
			}
		},
		methods: {
			onClick(event){
				this.$emit('click', event)
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.button.success-btn,
	.button.success-btn:hover,
	.button.success-btn:active{
		background: var(--primary, rgba(72, 142, 83, 0.93)) !important;
		color: #FFF;
	}
	.button.success-btn:hover{
		background: var(--primary, rgba(72, 142, 83, 0.93)) !important;
	}
	.button.success-btn:disabled{
		background: var(--neutral70, #C0C0C0) !important;
		color: var(--neutral50, #8D8D8D);
	}
</style>